import { render, staticRenderFns } from "./navigate-to-explain-search-button.component.vue?vue&type=template&id=601d89c7"
import script from "./navigate-to-explain-search-button.component.vue?vue&type=script&lang=ts"
export * from "./navigate-to-explain-search-button.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports